module.exports = __webpack_public_path__ + "static/img/gaozhonglishi4.1bad98da.jpg";